var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('AppHeader'), _vm._v(" "), _c('div', {
    staticClass: "app-body"
  }, [_c('Sidebar'), _vm._v(" "), _c('main', {
    staticClass: "main"
  }, [(_vm.isDisplay) ? _c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    class: !_vm.isDisplay ? 'noPadding' : ''
  }, [_c('router-view', {
    attrs: {
      "rootMethods": _vm.mappingObj
    }
  })], 1)], 1), _vm._v(" "), _c('AppAside')], 1), _vm._v(" "), _c('AppFooter')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2860d456","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full.vue
// module id = 360
// module chunks = 1